import {
	chainCommands,
	createParagraphNear,
	liftEmptyBlock,
	newlineInCode,
	splitBlock,
} from 'prosemirror-commands';
import { GapCursor } from 'prosemirror-gapcursor';
import type { Command } from 'prosemirror-state';
import {
	AllSelection,
	Plugin,
	Selection,
	TextSelection,
} from 'prosemirror-state';
import Extension from '../lib/Extension';

export default class Keys extends Extension {
	get name() {
		return 'keys';
	}

	keys(): Record<string, Command> {
		return {
			Enter: () => this.editorState.singleLineEditor,
			'Shift-Enter': chainCommands(
				newlineInCode,
				createParagraphNear,
				liftEmptyBlock,
				splitBlock
			),
		};
	}

	get plugins() {
		return [
			new Plugin({
				props: {
					// We can't use the keys bindings for this as we want to preventDefault
					// on the original keyboard event when handled
					handleKeyDown: (view, event) => {
						if (view.state.selection instanceof AllSelection) {
							if (event.key === 'ArrowUp') {
								const selection = Selection.atStart(view.state.doc);
								view.dispatch(view.state.tr.setSelection(selection));
								return true;
							}
							if (event.key === 'ArrowDown') {
								const selection = Selection.atEnd(view.state.doc);
								view.dispatch(view.state.tr.setSelection(selection));
								return true;
							}
						}

						// Edge case where horizontal gap cursor does nothing if Enter key
						// is pressed. Insert a newline and then move the cursor into it.
						if (view.state.selection instanceof GapCursor) {
							if (event.key === 'Enter' && !this.editorState.singleLineEditor) {
								view.dispatch(
									view.state.tr.insert(
										view.state.selection.from,
										view.state.schema.nodes.paragraph.create({})
									)
								);
								view.dispatch(
									view.state.tr.setSelection(
										TextSelection.near(
											view.state.doc.resolve(view.state.selection.from),
											-1
										)
									)
								);
								return true;
							}
						}

						return false;
					},
				},
			}),
		];
	}
}
